export enum ValueUnit {
    Time = 0,
    Cycles = 1
}
